var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-item",on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.item.iconName))]),_c('label',[_vm._v(_vm._s(_vm.item.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }